var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.1719 11.2285C24.1719 10.676 23.9579 10.1461 23.5769 9.75538C23.196 9.36468 22.6793 9.14518 22.1406 9.14518H15.7219L16.6969 4.38477C16.7172 4.2806 16.7273 4.16602 16.7273 4.05143C16.7273 3.62435 16.5547 3.22852 16.2805 2.94727L15.2039 1.85352L8.52109 8.70768C8.14531 9.0931 7.92188 9.61393 7.92188 10.1868V20.6035C7.92188 21.156 8.13588 21.686 8.51681 22.0767C8.89775 22.4674 9.4144 22.6868 9.95312 22.6868H19.0938C19.9367 22.6868 20.6578 22.166 20.9625 21.416L24.0297 14.0723C24.1211 13.8327 24.1719 13.5827 24.1719 13.3118V11.2285ZM1.82812 22.6868H5.89062V10.1868H1.82812V22.6868Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLike);
export default __webpack_public_path__ + "static/media/mdi_like.5951b18ad5b095edd59c81678bb650fc.svg";
export { ForwardRef as ReactComponent };